/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AdvancedEcommerceTemplate,
  AdvancedLevel,
  AdvancedNewsletterTemplate,
  BasicEcommerceTemplate,
  BasicNewsletterTemplate,
  BasicStandardTemplate,
  BeginnerLevel,
  BlankTemplate,
  IntermediateLevel,
  OneColumnTemplate,
  SimpleTemplate,
  SingleItemTemplate,
} from 'ui/icons';

import { DragAndDrop, SideBySide, WYSIWYG } from './assets';

export const content = {
  modalHeader: {
    prefix: 'New',
    suffix: 'template',
  },
  templateNameInput: { label: 'Template name' },
  templateEditorSelector: {
    dragDrop: {
      title: 'Drag and Drop',
      tooltip: 'A drag-and-drop interface for arranging modular template elements',
    },
    wysiwyg: { title: 'WYSIWYG', tooltip: 'A familiar, point-and-click text editor' },
    sideBySide: {
      title: 'Side by Side',
      tooltip: 'A two-column interface for editing and previewing HTML',
    },
  },
  dragDropSelector: {
    description: 'Start from scratch or use one of the Drag and Drop compatible quick templates.',
  },
  createTemplateButtonText: 'Create template',
  continueButtonText: 'Continue',
  levelTexts: {
    beginnerText: 'Beginner HTML level',
    intermediateText: 'Intermediate HTML level',
    advancedText: 'Advanced HTML level',
  },
};

export const TEMPLATE_EDITOR_OPTIONS = {
  DRAG_AND_DROP: {
    image: DragAndDrop,
    level: BeginnerLevel,
    levelText: content.levelTexts.beginnerText,
  },
  WYSIWYG: {
    image: WYSIWYG,
    level: IntermediateLevel,
    levelText: content.levelTexts.intermediateText,
  },
  SIDE_BY_SIDE: {
    image: SideBySide,
    level: AdvancedLevel,
    levelText: content.levelTexts.advancedText,
  },
};

export const DRAG_DROP_OPTIONS = {
  blank: {
    id: 'BF-empty',
    label: 'Blank',
    altText: 'Blank template',
    svg: BlankTemplate,
  },
  oneCol: {
    id: 'BF-basic-onecolumn',
    label: 'One Column',
    altText: 'Basic one-column template',
    svg: OneColumnTemplate,
  },
  basicEcon: {
    id: 'BF-basic-e-commerce',
    label: 'Basic ecommerce',
    altText: 'Basic e-commerce template',
    svg: BasicEcommerceTemplate,
  },
  advEcon: {
    id: 'BF-ecommerce-template',
    label: 'Advanced ecommerce',
    altText: 'Advanced e-commerce template',
    svg: AdvancedEcommerceTemplate,
  },
  simple: {
    id: 'BF-simple-template',
    label: 'Simple',
    altText: 'Simple one-column layout',
    svg: SimpleTemplate,
  },
  single: {
    id: 'BF-promo-template',
    label: 'Single item promotional',
    altText: 'A single-column promo layout, good for promoting a specific item',
    svg: SingleItemTemplate,
  },
  basicNews: {
    id: 'BF-basic-newsletter',
    label: 'Basic newsletter',
    altText:
      'A one-column newsletter style layout, with images on the left-hand side, and text on the right',
    svg: BasicNewsletterTemplate,
  },
  advNews: {
    id: 'BF-newsletter-template',
    label: 'Advanced newsletter',
    altText: 'A more advanced newsletter layout',
    svg: AdvancedNewsletterTemplate,
  },
  basicStand: {
    id: 'BF-basic-standard',
    label: 'Basic standard',
    altText: 'A one-column standard layout',
    svg: BasicStandardTemplate,
  },
};

const { levelTexts, ...EmailContent } = content;
const { continueButtonText, dragDropSelector, ...InAppContent } = EmailContent;
const { templateEditorSelector, ...SimpleContent } = InAppContent;

export { EmailContent, InAppContent, SimpleContent };
